import {
    serverBus
} from '@/main'
import VueSignals from '@/scripts/VueSignals';
export default {
    name: 'KeyboardShortcut',
    data() {
        return {
            rightSidebarTheme: '',
        }
    },
    mounted() {
        serverBus.$on(VueSignals.RIGHT_SIDEBAR_THEME, (theme) => {
            this.rightSidebarTheme = theme
        })

    },
    methods: {}
}
